<template>
  <Dialog
    :title="type === 'add' ? '新增字典类型' : '修改字典类型'"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="字典名称" prop="dictName">
        <el-input
          v-model.trim="form.dictName"
          placeholder="请输入字典名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="字典类型" prop="dictType">
        <el-input
          v-model.trim="form.dictType"
          :disabled="!!form.dictId"
          placeholder="请输入字典类型"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio label="0">正常</el-radio>
          <el-radio label="1">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          v-model.trim="form.remark"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button plain round size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import { getDictType, addDictType, updateDictType } from "@/api/system";

const defaultForm = () => ({
  dictId: undefined,
  dictName: "",
  dictType: "",
  status: "0",
  remark: ""
});

export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      form: defaultForm(),
      rules: {
        dictName: [
          { required: true, message: "请输入字典名称", trigger: "blur" }
        ],
        dictType: [
          { required: true, message: "请输入字典类型", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }]
      }
    };
  },
  methods: {
    async open(type, row = {}) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit" && row.dictId) {
        try {
          const result = await getDictType(row.dictId);

          this.form = {
            dictId: result.data.dictId,
            dictName: result.data.dictName,
            dictType: result.data.dictType,
            status: result.data.status || "0",
            remark: result.data.remark || ""
          };
          this.$nextTick(() => {
            this.$refs.formRef && this.$refs.formRef.clearValidate();
          });
        } catch (e) {
          this.cancel();
        }
      } else {
        this.form = defaultForm();
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate();
        });
      }
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return false;
      }
      this.submitLoading = true;
      const request = this.form.dictId ? updateDictType : addDictType;
      try {
        const result = await request(this.form);

        this.$message.success(this.form.dictId ? "编辑成功" : "保存成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
      this.$refs.formRef && this.$refs.formRef.resetFields();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/system/Dict/DictForm.vue